module.exports = __webpack_public_path__ + "static/img/stay-opiotn-icon-wifi.25824b0f.svg";